import { useMemo } from 'react'

function useTourDepartureRoomInventory(tourOffer: Tours.V2Offer, departureId: string | undefined) {
  const departureRoomInventory = useMemo(() => {
    const roomTypeInventoryMap = new Map()
    if (tourOffer && departureId) {
      const departurePurchasableOptions = tourOffer.purchasableOptions.filter(purchasableOption => {
        return purchasableOption.fkDepartureId === departureId
      })
      departurePurchasableOptions?.forEach(purchasableOption => {
        roomTypeInventoryMap.set(purchasableOption.roomType!, purchasableOption.inventoryLeft)
      })
    }
    return roomTypeInventoryMap
  }, [tourOffer, departureId])

  return departureRoomInventory
}

export default useTourDepartureRoomInventory
